import { useCallback, useMemo, useState } from 'react';
import type { ReviewLayout } from '@nest-recruit/shared';
import { createUserPreferenceStore } from '../../../lib/preferences';
import { useCurrentSession } from '../../../stores/session';

/** D6 (ADR 0080): ④ Review opens as the list; a person who picks the board keeps it, on any device (06-qol §3). */
export const REVIEW_LAYOUT_KEY = 'table.review.layout';

export function useReviewLayout(): readonly [ReviewLayout, (layout: ReviewLayout) => void] {
  const userId = useCurrentSession()?.id ?? 'anonymous';
  const store = useMemo(() => createUserPreferenceStore(userId), [userId]);
  const [layout, setLayoutState] = useState<ReviewLayout>(() => (store.get<string>(REVIEW_LAYOUT_KEY, 'list') === 'board' ? 'board' : 'list'));
  const setLayout = useCallback(
    (next: ReviewLayout): void => {
      setLayoutState(next);
      store.set(REVIEW_LAYOUT_KEY, next);
    },
    [store],
  );
  return [layout, setLayout];
}
